import * as React from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import "@fontsource/lato";
import "@fontsource/montserrat";
import {Theme} from "../styles/styles";
import {ThemeProvider} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import {useEffect, useState} from "react";
import {useDebounce} from "use-debounce";
import {
    debounce,
    Radio,
    RadioGroup,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import {Libs} from "../../App/libs";
import {DEF} from "../../const";

export const InputIconTextItem = ({
                                      id,
                                      isEmail = false,
                                      isPhone = false,
                                      isDescription,
                                      label,
                                      name,
                                      disabled,
                                      placeholder = "wpisz tekst...",
                                      text = null,
                                      text2 = null,
                                      getValue,
                                      icon,
                                      customWidth = "34.7%",
                                      customHeight = "55px",
                                      multiLine = false,
                                      minRows,
                                      maxRows,
                                      error,
                                      helperText,
                                      delay = 1000,
                                      onChangeActionHandler,
                                      onChangeServicesList,
                                      onChangeHistoryHandler,
                                      type = "text",
                                      checkIsPhoneValidated,
                                      checkIsEmailValidated,
                                      maxLength,
                                      onValidateBeforeSave,
                                      serviceName,
                                  }) => {
    console.log('InputIconTextItem :', {'label': label, 'name': text, 'serviceName': serviceName});


    const MINUTE_MAX_FREE = DEF.MAX_MINUTES_IN_MONTH;
    const MINUTE_FREE = -1;
    const MINUTE_NONE_FREE = -2;

    const SELECT_MINUTE_NONE_FREE = "brak";
    const SELECT_MINUTE_SET_VALUE = "wybor";
    const SELECT_MINUTE_ALL_FREE = "noLimit";

    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isValidPhoneNumber, setIsValidPhoneNumber] = useState(true);
    const [showWarningDialog, setShowWarningDialog] = useState(false);

    const [value, setValue] = useState(() => {
        let tmp = text ? text : text2;
        if (name === 'Telefonia' && type === 'number') {
            return Number(tmp) === 0 ? MINUTE_NONE_FREE  : tmp;
        }
        return tmp;
    });

    const transformValueToCheckBox = (tmp) => {
        const num = Number(tmp);

        if (num === MINUTE_MAX_FREE || num === MINUTE_FREE) {
            return SELECT_MINUTE_ALL_FREE;
        }

        if (num === MINUTE_NONE_FREE) {
            return SELECT_MINUTE_NONE_FREE;
        }

        return SELECT_MINUTE_SET_VALUE;
    };


    const [freeMinutesOption, setFreeMinutesOption] = useState(() =>
        transformValueToCheckBox(text ? text : text2)
    );


    useEffect(() => {
        if (type === "number") {
            setFreeMinutesOption(transformValueToCheckBox(value));
        }
    }, [value, type]);

    const [debounceValue] = useDebounce(value, delay);
    useEffect(() => {
        const finalValue = Number(debounceValue) === MINUTE_NONE_FREE ? 0 : debounceValue;
        getValue && getValue(finalValue);
    }, [debounceValue, getValue]);

    useEffect(() => {
        if (type === "number") {
            setFreeMinutesOption(transformValueToCheckBox(value));
        }
    }, [value, type]);

    useEffect(() => {
        getValue && getValue(debounceValue);
    }, [debounceValue, getValue]);


    useEffect(() => {
        isEmail && checkIsEmailValidated(isValidEmail ? true : false);
        isPhone && checkIsPhoneValidated(isValidPhoneNumber ? true : false);
    }, [isValidPhoneNumber, isValidEmail]);

    const handleChange = (event) => {
        const tmpValue = event.target.value;

        if (event.target.type !== undefined && event.target.type === 'FreeMinute') {
            const valueForServer = Number(tmpValue) === MINUTE_NONE_FREE ? 0 : tmpValue;
            event.preventDefault();
            setValue(tmpValue);
            onChangeActionHandler &&
            onChangeActionHandler({[event.target.name]: valueForServer});

            onChangeServicesList &&
            onChangeServicesList({[event.target.name]: valueForServer}, id, isDescription);

            onChangeHistoryHandler &&
            onChangeHistoryHandler(valueForServer);
        } else {

            isEmail && setIsValidEmail(Libs.validateEmail(tmpValue));
            isPhone && setIsValidPhoneNumber(Libs.validatePhoneNumber(tmpValue));
            event.preventDefault();
            setValue(event.target.value);
            onChangeActionHandler &&
            onChangeActionHandler({[event.target.name]: event.target.value});
            onChangeServicesList &&
            onChangeServicesList(
                {[event.target.name]: event.target.value},
                id,
                isDescription
            );
            onChangeHistoryHandler && onChangeHistoryHandler(event.target.value);
        }
    };

    const keyPress = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    };

    const drawTelefoniaRaw = () => {

        return (
            <Box>
                {type === 'number' && (
                    <RadioGroup
                        row
                        value={freeMinutesOption}
                        onChange={(event) => {
                            const option = event.target.value;

                            let newValue = value;
                            if (option === SELECT_MINUTE_ALL_FREE) newValue = MINUTE_MAX_FREE;
                            if (option === SELECT_MINUTE_NONE_FREE) newValue = MINUTE_NONE_FREE;
                            if (option === SELECT_MINUTE_SET_VALUE) newValue = 0;

                            const fakeEvent = {
                                target: {
                                    type: 'FreeMinute',
                                    value: newValue,
                                    name: name
                                },
                                preventDefault: () => {}
                            };

                            handleChange(fakeEvent);
                        }}
                        sx={{ mb: 2 }}
                    >
                        <FormControlLabel
                            value={SELECT_MINUTE_NONE_FREE}
                            control={<Radio size="small" />}
                            label="Brak darmowych"
                            sx={{ '& .MuiFormControlLabel-label': { fontFamily: "Lato", fontSize: 14 } }}
                        />
                        <FormControlLabel
                            value={SELECT_MINUTE_ALL_FREE}
                            control={<Radio size="small" />}
                            label="Bez limitu"
                            sx={{ '& .MuiFormControlLabel-label': { fontFamily: "Lato", fontSize: 14 } }}
                        />
                        <FormControlLabel
                            value={SELECT_MINUTE_SET_VALUE}
                            control={<Radio size="small" />}
                            label="Określona ilość"
                            sx={{ '& .MuiFormControlLabel-label': { fontFamily: "Lato", fontSize: 14 } }}
                        />
                    </RadioGroup>
                )}

                {(type !== 'number' || freeMinutesOption === SELECT_MINUTE_SET_VALUE) && (
                    <InputBase
                        sx={{
                            ml: 1,
                            flex: 1,
                            fontFamily: "Lato",
                            fontSize: 14,
                            color: "#363636",
                            fontWeight: "normal",
                            width: "100%",
                            backgroundColor: "#fff",
                            border: type === 'number' ? '1px solid #ccc' : 'none',
                            padding: '4px 8px'
                        }}
                        id={id}
                        type={type}
                        minRows={minRows}
                        maxRows={maxRows}
                        placeholder={placeholder}
                        name={name}
                        value={value}
                        disabled={disabled}
                        onChange={(event) => debounce(handleChange(event), 1000)}
                        multiline={multiLine}
                        inputProps={{
                            "aria-label": "wprowadź dane",
                            maxLength: maxLength,
                        }}
                        error={error}
                        helpertext={helperText}
                    />
                )}
            </Box>
        );
    };

    const drawDefaultRaw = () => {
        return (

            <InputBase
                sx={{
                    ml: 1,
                    flex: 1,
                    fontFamily: "Lato",
                    fontSize: 14,
                    color: "#363636",
                    fontWeight: "normal",
                    width: "100%",
                    backgroundColor: "#fff"
                }}
                id={id}
                type={type}
                minRows={minRows}
                maxRows={maxRows}
                placeholder={placeholder}
                name={name}
                value={value}
                disabled={disabled}
                onChange={(event) => debounce(handleChange(event), 1000)}
                multiline={multiLine}
                inputProps={{
                    "aria-label": "wprowadź dane",
                    maxLength: maxLength,
                }}
                error={error}
                helpertext={helperText}
            />
        );
    };

    return (
        <ThemeProvider theme={Theme}>
            <Paper
                component="form"
                sx={{
                    p: "10px 16px 2px 24px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    width: customWidth,
                    minHeight: customHeight,
                    maxHeight: "300px",
                    overflow: "auto",
                    borderTop: "1px solid var(--color-primary-black)",
                }}
            >
                <Box
                    sx={{
                        width: "96%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "center",
                    }}
                >
                    <Typography variant="body1">{label}</Typography>
                    {(() => {
                        switch (name) {
                            case 'Telefonia' :
                                return drawTelefoniaRaw();
                            default:
                                return drawDefaultRaw();
                        }
                    })()}

                </Box>
                {icon && (
                    <IconButton
                        type="button"
                        sx={{
                            bgcolor: "#2bfece",
                            width: "28px",
                            height: "28px",
                            mt: -5,
                            alignSelf: "center",
                        }}
                        aria-label="search"
                        onClick={() => {
                            setValue("");
                        }}
                    >
                        {icon}
                    </IconButton>
                )}
            </Paper>
            <Typography variant="bodyMediumRegural" marginTop={-17} color="#db2251">
                {!isValidEmail && isEmail ? "Nieprawidłowy adres email !! " : ""}
            </Typography>
            <Typography variant="bodyMediumRegural" marginTop={-17} color="#db2251">
                {!isValidPhoneNumber && isPhone
                    ? "Nieprawidłowy numer telefonu !! "
                    : ""}
            </Typography>
            <Dialog
                open={showWarningDialog}
                onClose={() => setShowWarningDialog(false)}
            >
                <DialogTitle>Ostrzeżenie</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Wartość darmowych minut wynosi 0, a opcja jest ustawiona na "Określona ilość".
                        Proszę wprowadzić wartość większą od 0 lub wybrać inną opcję.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowWarningDialog(false)} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};

InputIconTextItem.propTypes = {
    label: PropTypes.string,
    text: PropTypes.string,
};
